import { Empty } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import LayeredTableHeader from '../LayeredTableHeader/LayeredTableHeader';
import LayeredTableRow from '../LayeredTableRow/LayeredTableRow';
import styles from './LayeredTable.module.scss';
import classNames from 'classnames';

const LayeredTable = ({
  rootClassName,
  officeData,
  data,
  rowClassName,
  lightTheme,
  expandable,
  rowDataPropertiesArray,
  expandedRowContent,
  clickHighlighted,
  editable,
  deletable,
  rowOnClick,
  onDeleteRow,
  expandButtonFlex,
  onEditRow,
  isEditing,
  customGridTemplateColumns,
}) => {
  const columnsCount = useMemo(
    () => ({
      dataColumns:
        rowDataPropertiesArray.length + (expandable == 'start' ? 1 : 0),
      buttonColumns: [expandable === 'end', editable, deletable].filter(Boolean)
        .length,
    }),
    [rowDataPropertiesArray.length, expandable, editable, deletable]
  );

  return (
    <>
      <div
        className={classNames(styles.layeredTable, rootClassName, {
          [styles.themed]: !lightTheme,
          [styles.white]: lightTheme,
        })}
        style={{
          gridTemplateColumns: customGridTemplateColumns
            ? customGridTemplateColumns
            : 'max-content ' +
              '1fr '.repeat(columnsCount.dataColumns - 1) +
              ' ' +
              'fit-content(40px) '.repeat(columnsCount.buttonColumns),
        }}
      >
        <LayeredTableHeader
          editable={editable}
          deletable={deletable}
          expandable={expandable}
          rowDataPropertiesArray={rowDataPropertiesArray}
          expandButtonFlex={expandButtonFlex}
        />

        {data.map((entry, index) => (
          <LayeredTableRow
            key={entry.id ? entry.id : index}
            onEditRow={onEditRow}
            isEditing={isEditing}
            rowData={entry}
            className={rowClassName}
            editable={editable}
            deletable={deletable}
            expandable={expandable}
            lightTheme={lightTheme}
            rowOnClick={rowOnClick}
            onDeleteRow={onDeleteRow}
            clickHighlighted={clickHighlighted}
            expandedRowContent={expandedRowContent}
            rowDataPropertiesArray={rowDataPropertiesArray}
            expandButtonFlex={expandButtonFlex}
            officeData={officeData}
            columnsCount={columnsCount.dataColumns + columnsCount.buttonColumns}
          />
        ))}
      </div>
      {!data.length && (
        <div
          className={classNames(styles.layeredTable, {
            [styles.themed]: !lightTheme,
            [styles.white]: lightTheme,
          })}
        >
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      )}
    </>
  );
};

LayeredTable.propTypes = {
  officeData: PropTypes.object, // на случай, когда нужно отрисовать данные помещения при открытии модалки
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowClassName: PropTypes.string,
  style: PropTypes.object,
  expandable: PropTypes.oneOf(['start', 'end', false]), // либо кнопка расширения ряда находится в начале ряда, либо в конце, либо ее нет
  rowDataPropertiesArray: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      highlight: PropTypes.bool,
    })
  ).isRequired, // перечислить ключи обьекта, значения которого нарисуются в ряду
  expandedRowContent: PropTypes.elementType,
  expandButtonFlex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowOnClick: PropTypes.func, // онклик на ряд
  lightTheme: PropTypes.bool,
  clickHighlighted: PropTypes.func, // при клике на выделенные голубые имена помещений/объектов и тд
};

export default memo(LayeredTable);
